"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var global_1 = require("../global");
var tool = require("../tool");
var Canvas = /** @class */ (function (_super) {
    __extends(Canvas, _super);
    function Canvas() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Canvas.parseAttributeValue = function (attr, value) {
        switch (attr) {
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Canvas.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _renderer: function () { return undefined; } });
    };
    Canvas.prototype.init = function () {
        _super.prototype.init.call(this);
    };
    Canvas.prototype.render = function () {
        if (!this._preRender()) {
            return;
        }
        if (this._isDirty(["_x", "_y", "_width", "_height"])) {
            this.setTransform();
        }
        this._render();
        var renderer = this._options._renderer;
        var ctx = this.dom.node().getContext("2d");
        var bound = this.computedSize(null, true);
        renderer.call(this, ctx, this.datum, bound);
        this._postRender();
    };
    Canvas.prototype.appendSelf = function (checkAppended) {
        if (checkAppended === void 0) { checkAppended = true; }
        if (checkAppended && this._appended) {
            return;
        }
        if (this._data && (!(this._data instanceof Array) || this._data.length > 0)) {
            console.warn("You seems to be supplying data to a non-group element. Use datum instead.", this);
        }
        var dataKey = this.datum.__dataKey__;
        if (typeof dataKey === "string") {
            this.__dataKey__ = dataKey;
            var data = global_1.default.currentVisualizer.data[dataKey];
            if (typeof data === "undefined") {
                console.error("Data for data key " + dataKey + " is undefined");
            }
            else {
                this.datum = data;
                global_1.default.currentVisualizer.registerListener(dataKey, this);
            }
        }
        this._fo = this.parent.dom
            .append("foreignObject")
            .datum(this.datum);
        this._foBody = this._fo.append("xhtml:body");
        this.dom = this._foBody.append("canvas")
            .attr("x", 0).attr("y", 0)
            .classed(this._uuid, true);
        this._appended = true;
        this.postAppend();
    };
    Canvas.prototype.enterAppendSelf = function () {
        console.error("Canvas doesn't support enter append!");
    };
    Canvas.prototype.setTransform = function () {
        var bound = this.computedSize(null, true);
        var anchor = this.getOption("_anchor");
        var _a = _1.positionOffsetedByAnchor(bound, anchor), x = _a.x, y = _a.y;
        var rotation = "";
        if (this._options._rotation) {
            var r = this.getOption("_rotation");
            rotation = tool.rotateWithOrigin.apply(this, r);
        }
        this._fo.attr("x", x).attr("y", y)
            .attr("width", bound.width)
            .attr("height", bound.height);
        this._foBody.style("margin", "0px")
            .style("padding", "0px")
            .style("background", "none")
            .style("width", bound.width + "px")
            .style("height", bound.height + "px");
        this.dom.attr("x", 0).attr("y", 0)
            .attr("width", bound.width)
            .attr("height", bound.height);
    };
    return Canvas;
}(_1.Component));
exports.Canvas = Canvas;
//# sourceMappingURL=canvas.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/canvas.js
// module id = 1156
// module chunks = 0 1